export const ExerciseStatus = {
	PASSED: 'passed', // Score > 0.8
	LOCKED: 'locked', //
	OPEN: 'open', // Current exercise, not started yet
	ONGOING: 'ongoing', // Started, doing but not yet pass
};
